import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import React from 'react';

interface SurveyEmoji1Props {
  color?: string;
  style?: React.CSSProperties;
}

export const SurveyEmoji1Icon = ({ color = RoutalPalette.white, style = {}, ...props }: SurveyEmoji1Props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 30 31" style={{ width: `30px`, height: `31px`, ...style }}>
      <ellipse cx="14.9992" cy="15.4038" rx="14.9914" ry="15" fill="url(#paint0_linear_538_25379)" />
      <path
        d="M18.031 13.272C18.0242 13.272 18.0175 13.272 18.0097 13.272C16.6607 13.272 15.4465 13.7452 14.7599 14.5395C14.4011 14.9546 14.4457 15.5811 14.8608 15.9399C15.0489 16.1028 15.2797 16.1823 15.5105 16.1823C15.7889 16.1823 16.0653 16.066 16.2612 15.839C16.5123 15.5491 17.1495 15.2581 18.0097 15.2581C18.0146 15.2581 18.0194 15.2581 18.0233 15.2581C18.8728 15.261 19.5148 15.5481 19.7747 15.8303C20.1471 16.2357 20.7746 16.2609 21.178 15.8895C21.5815 15.518 21.6086 14.8906 21.2372 14.4862C20.5428 13.7307 19.3441 13.2768 18.031 13.272Z"
        fill="#4D4D4D"
      />
      <path
        d="M14.4453 8.23577C14.6157 8.34954 14.8086 8.40374 14.999 8.40374C15.3222 8.40374 15.6391 8.24749 15.832 7.95843C16.1382 7.49896 16.0141 6.87786 15.5547 6.57171L12.5547 4.57171C12.0947 4.26458 11.4741 4.38958 11.168 4.84905C10.8618 5.30852 10.9858 5.92962 11.4453 6.23577L14.4453 8.23577Z"
        fill="#4D4D4D"
      />
      <path
        d="M20.5547 8.23577C20.3843 8.34954 20.1914 8.40374 20.001 8.40374C19.6778 8.40374 19.3609 8.24749 19.168 7.95843C18.8618 7.49896 18.9859 6.87786 19.4453 6.57171L22.4453 4.57171C22.9053 4.26458 23.5259 4.38958 23.832 4.84905C24.1382 5.30852 24.0142 5.92962 23.5547 6.23577L20.5547 8.23577Z"
        fill="#4D4D4D"
      />
      <path
        d="M13.5 12.4038C14.3284 12.4038 15 11.5084 15 10.4038C15 9.29924 14.3284 8.40381 13.5 8.40381C12.6716 8.40381 12 9.29924 12 10.4038C12 11.5084 12.6716 12.4038 13.5 12.4038Z"
        fill="#4D4D4D"
      />
      <path
        d="M21.5 12.4038C22.3284 12.4038 23 11.5084 23 10.4038C23 9.29924 22.3284 8.40381 21.5 8.40381C20.6716 8.40381 20 9.29924 20 10.4038C20 11.5084 20.6716 12.4038 21.5 12.4038Z"
        fill="#4D4D4D"
      />
      <defs>
        <linearGradient
          id="paint0_linear_538_25379"
          x1="14.9992"
          y1="30.4038"
          x2="14.9992"
          y2="0.403809"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.360326" stop-color="#FEC654" />
          <stop offset="1" stop-color="#D62C20" />
        </linearGradient>
      </defs>
    </SvgIcon>
  );
};
